export enum IconListIconBackgroundColor {
  WHITE = 'white',
  GREY = 'grey',
}